import { gql } from 'apollo-angular';

export const QUOTE_PRICING_STATE_FRAGMENT = gql`
  fragment QuotePricingStateFragment on Quote {
    autoUpdatePrices
    priceIsOutdated
  }
`;
